var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Transition", { attrs: { name: "fade-slide-up", appear: "" } }, [
    _vm.displayLimit
      ? _c(
          "div",
          {
            staticClass:
              "premium-bg text-white br-8 vue-result-limits position-relative shadow mt-3 d-none d-sm-block",
          },
          [
            _c(
              "span",
              {
                staticClass:
                  "position-absolute cursor-pointer d-block font-size-200 top-0 right-0 mt-4 mr-4 line-height-1ch fg-white",
                class: { "opacity-65": _vm.isStateLoading },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.dismiss()
                  },
                },
              },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-start flex-column p-4" },
              [
                _c("strong", { staticClass: "font-size-125 mb-4 w-100 pr-4" }, [
                  _vm._v(_vm._s(_vm.limitTitle)),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "mb-5 vue-result-limits-description" },
                  [_vm._v(_vm._s(_vm.limitText))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "w-100 d-flex align-items-center justify-content-between vue-result-limits-button-container",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "mr-4 text-white cursor-pointer hover-underline vue-result-limits-dismiss-text",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.dismiss()
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")(
                              "No thanks, I don't want fast, unlimited access"
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("ButtonWithLoadingState", {
                      staticClass:
                        "btn btn-warning font-weight-bold white-space-nowrap font-size-125 px-4 py-3",
                      attrs: {
                        "is-state-loading": _vm.isStateLoading,
                        text: _vm.goPremiumText,
                        icon: "m-l-5 fa fa-arrow-right",
                        "show-icon-after-text": true,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.doPremium.apply(null, arguments)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }